export default "__VITE_ASSET__cf3313cf__"